module.exports = __webpack_public_path__ + "20230117/img/slide2_titles.ef61ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2_titles.png
// module id = cJxY
// module chunks = 1